import PropTypes from 'prop-types';
import { includes, values } from 'ramda';

export const REGION_REGIONAL = {
  AUVERGNE: 'auvergne_rhone_alpes',
  BOURGOGNE: 'bourgogne_franche_comte',
  BRETAGNE: 'bretagne',
  CENTRE: 'centre_val_de_loire',
  CORSE: 'corse',
  DOM: 'dom',
  GRAND_EST: 'grand_est',
  HAUTS_DE_FRANCE: 'hauts_de_france',
  ILE_DE_FRANCE: 'ile_de_france',
  NORMANDIE: 'normandie',
  NOUVELLE_AQUITAINE: 'nouvelle_aquitaine',
  OCCITANIE: 'occitanie',
  PACA: 'paca',
  PAYS_DE_LA_LOIRE: 'pays_de_la_loire',
};

export const REGION_NATIONAL = {
  NATIONAL: 'national',
  ...REGION_REGIONAL,
};

export const REGION_INTERNATIONAL = {
  AFRIQUE: 'afrique',
  AMERIQUE: 'ameriques',
  ASIE: 'asie',
  EUROPE: 'europe',
  OCEANIE: 'oceanie',
};

export const INTERNATIONAL = 'international';

export const REGION = {
  ...REGION_NATIONAL,
  ...REGION_INTERNATIONAL,
};

export const RegionType = PropTypes.oneOf(values(REGION));

export const isRegionalRegion = (value: string): boolean =>
  includes(value, values(REGION_REGIONAL));
export const isNationalRegion = (value: string): boolean =>
  includes(value, values(REGION_NATIONAL));
export const isInternationalRegion = (value: string): boolean =>
  includes(value, values(REGION_INTERNATIONAL));
